import React, { useState, useEffect } from 'react';
import Select from 'react-select';

import styles from './additionalFileUploadContainer.module.scss';
import {
  WithSpinner,
  Button,
  TableAdmin,
  TableRow,
  TableCell,
} from '../../components';
import swal from 'sweetalert';
import { connect } from 'react-redux';
import { actions } from './../../state/actions';
import { Api } from './../../api/api';
import { config } from './../../api/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import { fileTypeTranslation } from './../../utils/translation/translation';

const AdditionalFileUploadContainer = ({
  dispatch,
  loading,
  requestId,
  filesTableList,
  viewWindow,
  status,
}) => {
  const tableHeader = [
    'Priedo paskirtis',
    'Įkelto priedo pavadinimas',
    'Data',
    'Ar papildomas?',
    'Veiksmai',
  ];
  const [isLoading, setIsloading] = useState(false);
  const [fileType, setFileType] = useState(null);
  const [additional, setAdditional] = useState(null);

  const selectFile = (id) => {
    document.getElementById(id).click();
  };

  const gotoBottom = (id) => {
    window.scrollTo(0, document.body.scrollHeight);
  };

  const upload = (e) => {
    setIsloading(true);
    const file = e.target.files[0];

    if (file.size > 20 * 1048 * 1048) {
      setIsloading(false);

      swal({
        title: 'Įkeliamas priedas viršija 20mb leistiną limitą',
        icon: 'error',
        buttons: {
          confirm: {
            text: 'Gerai',
            value: true,
            visible: true,
            className: 'btn btn-pink',
            closeModal: true,
          },
        },
      });
    } else {
      const formData = new FormData();
      formData.append('Files', file);
      formData.append('RequestId', requestId);
      formData.append('FileType', fileType);
      formData.append('Additional', additional);

      fetch(Api.API_BASE_URL + config.API_ENDPOINTS.UploadFiles, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('userToken')}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.ok === true) {
            dispatch(actions.dashboard.getUploadedFileList(requestId));

            swal({
              title: 'Priedas sėkmingai įkeltas',
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn btn-pink',
                  closeModal: true,
                },
              },
            });
          } else if (res.status === 403) {
            swal({
              title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          } else {
            res.json().then((r) => {
              let title = 'Nepavyko pateikti priedo';
              if (r?.errors?.RequestId) {
                title = r.errors.RequestId[0];
              } else if (r.errors) {
                title = r.errors['Files[0].FileName'][0];
              } else if (r.ErrorDescription) {
                title = r.ErrorDescription;
              }
              swal({
                title: title,
                icon: 'error',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsloading(false);
          setTimeout(() => {
            gotoBottom();
          }, 2000);
        });
      //  dispatch(actions.dashboard.fileUploadAction(formData, 'upload'));
    }
  };

  const onFileTypeSelectorChange = ({ target: { name, value } }) => {
    setFileType(value === '-' ? null : value);
    setAdditional(value === '-' ? true : true);
  };

  const onFileTypeSelectChange = ({ value }) => {
    setFileType(value === '-' ? null : value);
    setAdditional(value === '-' ? true : true);
  };

  const [fileArr, setFileArray] = useState([]);
  const [rejection, setRejection] = useState(null);

  useEffect(() => {
    if (filesTableList && filesTableList.length !== 0 && status === 10) {
      setRejection(filesTableList.slice(-1)[0]);
      setFileArray([filesTableList]);
      setFileArray([...filesTableList].slice(0, filesTableList.length - 1));
    } else {
      setFileArray(filesTableList);
    }
  }, [filesTableList, status, rejection]);

  const deleteFile = (id) => {
    setIsloading(true);
    const requestIdFileId = `${requestId}/${id}`;
    fetch(
      Api.API_BASE_URL +
        config.API_ENDPOINTS.DeleteUploadedFile(requestIdFileId),
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('userToken')}`,
        },
      }
    )
      .then((res) => {
        if (res.ok === true) {
          dispatch(actions.dashboard.getUploadedFileList(requestId));

          swal({
            title: 'Priedas sėkmingai ištrintas',
            icon: 'success',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn btn-pink',
                closeModal: true,
              },
            },
          });
        } else {
          swal({
            title: 'Nepavyko pašalinti priedo',
            icon: 'error',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn swal-ok-btn',
                closeModal: true,
              },
            },
          });
        }
      })
      .catch((err) => {
        swal({
          title: 'Nepavyko pateikti priedo',
          icon: 'error',
          buttons: {
            confirm: {
              text: 'Gerai',
              value: true,
              visible: true,
              className: 'btn swal-ok-btn',
              closeModal: true,
            },
          },
        });
      })
      .finally(() => {
        setIsloading(false);
        setTimeout(() => {
          gotoBottom();
        }, 2000);
      });
  };

  const deleteConfirmation = (id) => {
    swal({
      title: 'Ar tikrai norite ištrinti šį failą?',
      icon: 'warning',
      showCancelButton: true,

      buttons: {
        confirm: {
          text: 'Taip',
          value: true,
          visible: true,
          className: 'btn swal-ok-btn',
          closeModal: true,
        },
        cancel: {
          text: 'Ne',
          value: false,
          visible: true,
          className: 'btn btn-primary',
          closeModal: true,
        },
      },
    }).then((result) => {
      if (result) {
        deleteFile(id);
      }
    });
  };

  const downloadRejectionFile = (requestId, id, fileName) => {
    setIsloading(true);
    fetch(Api.API_BASE_URL + config.API_ENDPOINTS.DownloadFile(requestId, id), {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('userToken')}`,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const acceptFiles = (fileType) => {
    if (+fileType === 3 || +fileType === 15) {
      return '.pdf, .adoc';
    }

    if (+fileType === 13) {
      return '.xlsx, .xls';
    }
    return '.xlsx, .xls, .doc, .docx, .adoc, .xml, .txt, .pdf';
  };

  return (
    <WithSpinner loading={isLoading}>
      <div className={styles.container}>
        {viewWindow && (status == 11 || status == 19) && (
          <h4>Papildomų priedų įkėlimas</h4>
        )}
        {viewWindow && (status == 11 || status == 19) && (
          <div className={styles.container}>
            <div style={{ display: 'flex' }}>
              <div className={styles.selectflex}>
                <label>Prisegamo priedo paskirtis</label>
                <select
                  name="InvoiceType"
                  style={{
                    height: '44px',
                  }}
                  id="scrollToFromTop"
                  onChange={onFileTypeSelectorChange}
                >
                  <option selected={fileType == null} value={null}>
                    {' '}
                    -{' '}
                  </option>

                  <option selected={fileType == 3} value={3}>
                    Verslo subjektą apibūdinantys dokumentai (1)
                  </option>
                  <option selected={fileType == 15} value={15}>
                    Vadovo asmens tapatybės dokumento kopija
                  </option>
                  <option selected={fileType == 13} value={13}>
                    Pareiškėjo veiklos (finansinių) duomenų detalizacijos forma
                    (2)
                  </option>

                  {/*} <option selected={fileType == 5} value={5}>
                    Verslo subjekto valdymo organo sprendimas dėl Paskolos
                    gavimo, turto įkeitimo ir įgaliotų asmenų sudaryti
                    atitinkamus sandorius paskyrimo
                </option>

                  <option selected={fileType == 6} value={6}>
                    Verslininko individualios veiklos registracijos dokumentai,
                    asmens tapatybės dokumento kopija ir laisvos formos
                    dokumentas, kuriame būtų nurodyti verslininko ir su juo
                    susijusių įmonių ryšiai
                  </option>*/}

                  {/*<option selected={fileType == 10} value={10}>
                    Motyvuotas paaiškinimas (3)
                  </option>

                  <option selected={fileType == 14} value={14}>
                    Įgaliojimas (4)
                </option>*/}

                  <option selected={fileType == 11} value={11}>
                    Kiti priemonės aprašyme nustatyti dokumentai (3)
                  </option>
                </select>
              </div>
              <span
                className={styles.disabled}
                style={{
                  width: '155px',
                  marginTop: '-5px',
                  marginLeft: '10px',
                }}
              >
                <span className={styles.textUptheButton}>
                  Pasirinkti priedą
                </span>

                <button
                  className={
                    fileType
                      ? 'btn ui-button btn-dark-blue-standart'
                      : 'btn ui-button btn-dark-blue-disabled'
                  }
                  type="longBtn"
                  onClick={() => selectFile('fileElem')}
                  disabled={!fileType}
                  style={{ marginTop: '9px', padding: '9px' }}
                >
                  PASIRINKTI PRIEDĄ
                </button>
                <input
                  type="file"
                  id="fileElem"
                  accept={acceptFiles(fileType)}
                  className="d-none"
                  onChange={upload}
                />
              </span>
            </div>
            <p className={styles.note}>
              Prisekite reikiamas rinkmenas. <br />
              Galimi priedų formatai: .xlsx, .xls, .doc, .docx, .xml, .txt,
              .pdf. Maksimalus dydis 20MB. <br />
              <br /> <br />
              <p>
                <b>Priedų formos atsisiuntimui:</b>
              </p>
              -{' '}
              <a
                href="https://ilte.lt/lt/doclib/eklnz8ia8gf3xddcszatns9ppdx1zhc4"
                target="_blank"
                rel="noreferrer noopener"
              >
                Detalizacijos forma
              </a>
              .
              {/*<p>
                <b>Priedų formos atsisiuntimui:</b>
              </p>
              <br />-{' '}
              <a target="_blank" href="/SVV-statuso-deklaracija.xlsx">
                Įmonės vadovo pasirašyta SVV deklaracija{' '}
              </a>
              (
              <a
                href="https://ilte.lt/duk/11/deklaracijos-2#!faq296"
                target="_blank"
                rel="noreferrer noopener"
              >
                Pildymo instrukcija
              </a>
              );
              <br />-{' '}
              <a target="_blank" href="/Aprasymo_priedas_Nr_1.xls">
                Aprašymo priedas Nr. 1
              </a>
              <br />-{' '}
              <a target="_blank" href="/Aprasymo_priedas_Nr_2.xlsx">
                Aprašymo priedas Nr. 2
              </a>
              <br /> <br />
              <b>Pastaba:</b> <br />
              (1) Įmonės Vadovo pasirašyta SVV subjekto statuso deklaraciją
              (išskyrus atvejį, kai Paskolos gavėjas patvirtina, kad yra didelė
              įmonė);
              <br />
              (2) Paskolos gavėjo esama ir prognozuojama finansinė būklė
              (skaičiavimai), atspindintys Paskolos gavėjo galimybę laiku mokėti
              įmokas pagal visus esamus ir būsimus Verslo subjekto finansinius
              įsipareigojimus visam Paskolos terminui;
              <br />
              (3) Paskolos gavėją apibūdinančius dokumentus: registracijos
              dokumentus, steigimo ir veiklos dokumentus (įstatus, nuostatus,
              bendrijos dalyvių sutartį ir pan.), vadovo asmens tapatybės
              dokumento kopijas, informaciją apie Verslo subjekto dalyvius
              (savininkus, naudos gavėjus), aktualią Paskolos gavėjo dalyvių
              struktūrą ir laisvos formos dokumentą, kuriame būtų nurodyti
              Paskolos gavėjo ir su juo susijusių įmonių ryšiai (netaikoma
              verslininkams, kurie neturi su jais susijusių įmonių);
              <br />
              (4) Verslo planas, kuriame aprašomas vykdomas verslas ir
              finansavimo poreikis, nurodoma esama ir prognozuojama finansinė
              būklė (skaičiavimai), atspindintys Verslo subjekto galimybę laiku
              mokėti įmokas pagal visus esamus ir būsimus Verslo subjekto
              finansinius įsipareigojimus visam Paskolos terminui, siūlymą dėl
              Paskolos užtikrinimo priemonių (jei taikoma);
              <br />
              (5) Verslininkas turi pateikti finansinius dokumentus už
              paskutiniuosius dvejus finansinius metus ar trumpesnį terminą (jei
              veikia trumpiau nei du metus);
              <br />
              *Esant poreikiui Verslo subjekto gali būti paprašyta pagrįsti
              duomenis pateikiant papildomus dokumentus.
              <br />
              (6) Jei dėl Paskolos kreipiasi ne PVM mokėtojas, jis turi pateikti
              buhalterinę pažymą apie importą arba eksportą į Kinijos Liaudies
              Respubliką (valstybės kodas CN) ir bendrą Paskolos gavėjo importą
              arba eksportą nuo 2021 m. sausio 1 d. iki 2021 m. gruodžio 31 d.;
              <br />
              (7)  Einamųjų finansinių metų tarpinio finansinių ataskaitų
              rinkinio už paskutinį praėjusį ketvirtį arba mėnesio, ėjusio prieš
              Paraiškos pateikimą, paskutinę dieną dokumentus. Jei Paskolos
              kreipiasi verslininkas, jis gali pateikti lygiaverčius dokumentus;{' '}
              <br />
              (8) Verslo subjektas teikdamas Paraišką ne pirmą kartą (t. y., kai
              ankstesnė (-s) Paraiška (-os) buvo atmesta (-os), turi pateikti
              motyvuotą paaiškinimą dėl įvykusių pokyčių Verslo subjekto
              veikloje ir su Paraiška teikiamuose dokumentuose (duomenyse) bei
              pateikti paaiškinimą pagrindžiančius dokumentus.
              </p>*/}
            </p>
          </div>
        )}
      </div>
      {rejection && (
        <div className={styles.container}>
          <h4> Sutarties nutraukimo dokumentas </h4>
          <p
            style={{ cursor: 'pointer' }}
            onClick={() =>
              downloadRejectionFile(requestId, rejection.Id, rejection.FileName)
            }
          >
            {rejection.FileName}
          </p>
        </div>
      )}
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboardState.isOnSync,
  filesTableList: state.dashboardState.filesTableList,
});

export default connect(mapStateToProps)(AdditionalFileUploadContainer);
